import { render } from "./DropdownContent.vue?vue&type=template&id=84d689b6"
import script from "./DropdownContent.vue?vue&type=script&lang=js"
export * from "./DropdownContent.vue?vue&type=script&lang=js"
script.render = render

export default script